
/**
Returns true if object is a Function.
*/

function isFunction(object){
	return (typeof object === 'function')
}

export var object = { isFunction }